"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const base_class_1 = require("./base.class");
class XsColorStore extends base_class_1.XsBaseClass {
    constructor(config = {}) {
        super(config);
        this.debugId = 'COLOR_STORE';
        this.debug = false;
        // copy of the plugin's controls
        this.controls = null;
        // reference to the colorManager (but try to remove this in the future)
        this.colorManager = null;
        // our caches
        this.colorsCache = {
            _resolutions: {}
        };
        this.renderedColorsCache = {};
        // our palette index lookup table
        this.paletteLut = null;
        if (config.controls) {
            this.controls = config.controls;
        }
        if (config.colorManager) {
            this.colorManager = config.colorManager;
        }
        if (config.paletteLut) {
            this.paletteLut = config.paletteLut;
        }
        // console.log( this.debugId + ' :: CONSTRUCTOR',this.controls,this.colorManager,this.paletteLut);
    }
    getName(name = '__current') {
        if (!name || name == '__current') {
            return this.controls.kind.value;
        }
        return name;
    }
    getResolution(resolution = null) {
        if (!resolution) {
            resolution = 100;
        }
        return parseInt(resolution);
    }
    getIndex(name = '__current', resolution = null) {
        if (!name || name == '__current') {
            name = this.controls.kind.value;
        }
        resolution = this.getResolution(resolution);
        if (!resolution || resolution == 'null') {
            return null;
        }
        return 'key_' + name + '_' + resolution;
    }
    resetColor(name = '__current') {
        name = this.getName(name);
        if (this.debug) {
            console.log('@@resetColor(' + name + ')', this.colorsCache['_resolutions']);
        }
        // go through all resolutions and delete their cache entry
        if (this.colorsCache._resolutions && this.colorsCache._resolutions[name]) {
            Object.keys(this.colorsCache._resolutions[name]).forEach(key => {
                let resolution = this.getResolution(key.substr(4));
                const idx = this.getIndex(name, resolution);
                if (this.colorsCache[idx]) {
                    this.colorsCache[idx] = null;
                    delete this.colorsCache[idx];
                }
                if (this.debug) {
                    console.log('@@resetColor(' + name + ') IDX', name, key, resolution, idx);
                }
            });
            this.colorsCache._resolutions[name] = null;
            delete this.colorsCache._resolutions[name];
        }
        if (this.debug) {
            console.log('@@resetColor(' + name + ') DONE', this.colorsCache);
        }
        // if ( this.colorsCache[idx+'_original'] ) {
        //     delete this.colorsCache[idx+'_original'];
        // }
    }
    getColors(name = '__current', resolution = null, getOriginal = false) {
        name = this.getName(name);
        const idx = this.getIndex(name, resolution);
        if (!name || !idx) {
            return null;
        }
        if (this.debug) {
            console.log('@@getColors(' + name + ')', idx, this.colorsCache[idx] ? true : false);
        }
        if (!this.colorsCache[idx]) {
            this.setColors(name, resolution, this.colorManager.getColors(name, { items: resolution }));
        }
        if (this.debug) {
            console.log('@@getColors(' + name + ') DONE', idx, getOriginal, this.colorsCache[idx]);
        }
        if (getOriginal) {
            return this.colorsCache[idx + '_original'];
        }
        return this.colorsCache[idx];
    }
    setColors(name = '__current', resolution = null, colors = []) {
        name = this.getName(name);
        resolution = this.getResolution(resolution);
        const idx = this.getIndex(name, resolution);
        if (!name || !idx) {
            return null;
        }
        this.colorsCache[idx] = [...colors];
        if (!this.colorsCache._resolutions[name]) {
            this.colorsCache._resolutions[name] = {};
        }
        this.colorsCache._resolutions[name]['key_' + resolution] = true;
        if (!this.colorsCache[idx + '_original']) {
            // make a copy of the original
            this.colorsCache[idx + '_original'] = [...colors];
        }
        if (this.debug) {
            console.log('@@setColors(' + name + ')', resolution, idx);
        }
    }
    /*
      processThese ( name:string = '__current', resolution:number = null ) {
        name = this.getName(name);
        if ( !resolution ) {
          return Object.keys(this.colorsCache._resolutions[name]).map( k => { parseInt(k) });
        }
        return [ resolution ];
      }
    */
    // bridge the colorStore to the colorManager
    getPaletteLut(name = '__current') {
        name = this.getName(name);
        const test = this.colorManager.getPaletteLut(name);
        if (this.debug) {
            console.log('@@getPaletteLut(' + name + ')', test);
        }
        return test;
    }
    // bridge the colorStore to the colorManager
    setPaletteLut(name = '__current', lut = []) {
        name = this.getName(name);
        this.colorManager.setPaletteLut(name, [...lut]);
        if (this.debug) {
            console.log('@@setPaletteLut(' + name + ')', lut);
        }
    }
    // process the index (for various orders of the colors)
    resetColors(name = '__current') {
        name = this.getName(name);
        let lut = this.getPaletteLut(name);
        lut.sort(function (a, b) { return a - b; });
        this.setPaletteLut(name, lut);
        this.resetColor(name);
    }
    reverseColors(name = '__current') {
        name = this.getName(name);
        let lut = this.getPaletteLut(name);
        lut = lut.reverse();
        this.setPaletteLut(name, lut);
        this.resetColor(name);
        /*
        name = this.getName(name);
        this.processThese ( name, resolution ).forEach ( key => {
          let colors = this.getColors(name,key);
          console.log('!reverseColor()', name, key, colors );
          if ( colors ) {
            this.setColors( name, key, colors.reverse() );
          }
          console.log('!reverseColor() DONE', name, key, this.getColors( name, key ) );
        });
        */
    }
    randomizeColors(name = '__current') {
        name = this.getName(name);
        let lut = this.getPaletteLut(name);
        lut = this.colorManager.randomizeArray(lut);
        this.setPaletteLut(name, lut);
        this.resetColor(name);
        /*
        name = this.getName(name);
        this.processThese ( name, resolution ).forEach ( key => {
          let colors = this.getColors(name,key);
          console.log('!randomizeColor()', name, key, colors );
          if ( colors ) {
            colors = this.colorManager.randomizeArray(colors);
            this.setColors( name, resolution, colors );
          }
          console.log('!randomizeColor() DONE', name, key, this.getColors( name, key ) );
        });
        */
    }
    getRenderedColors(name = '__current', renderMode = 'cesium', reset = false) {
        name = this.getName(name);
        const idx = this.getIndex(name);
    }
    setRenderedColors(name = '__current', renderMode = 'cesium', colors, reset = false) {
        name = this.getName(name);
        const idx = this.getIndex(name);
    }
}
exports.XsColorStore = XsColorStore;
